export const ADMIN_SIGN_IN_PATH = '/admin'

export const isAdminSignInPath = (pathname: string): boolean =>
  pathname.replace(/\/+$/, '') === ADMIN_SIGN_IN_PATH
